export const ViewSettingsText = "View Settings";
export const CommunicationSettingsText = "Communication Settings";
export const AdministratorAccessOnly = "Administrator Access Only";
export const AdminAccessText =
	"Tandem support personnel (such as Care and Account Managers) are unable to change any settings below. Please contact the listed Account Admin(s) for assistance.";
export const AccountAdminsHeaderText = "Account Admins:";
export const ShowPricingUnavailableLabel = "Pricing Information Unavailable";
export const ReceiveAcknowledgementEmailsOptionText = "Receive Acknowledgement Emails";
export const ReceiveAcknowledgementEmailsDescriptionText =
	"You will receive acknowledgement emails from orders you place or that have your Designer Number.";
export const UserSettingsHeaderText = "User Settings";
export const NameLabelText = "Name";
export const EmailLabelText = "Email";
export const PricingFormatLabelText = "Pricing Format";
export const SearchPeopleInputText = "Search People";
export const AllPeopleHeaderText = "All People";
export const AllStoresHeaderText = "All Stores";
export const PersonSettingsHeaderText = "View Settings";
export const PricingFormatSettingsLabel = "Pricing Format for Acknowledgements & Order Details";
export const SavingUserPermissionsText = "Saving user permissions...";
export const UserPermissionsSuccessfullySavedText = "User permissions successfully saved.";
export const NewUserPermissionsSaveErrorText = "Failed to save user permission changes. Please try again.";
export const PersonSearchNoResultsFound = "No users found.";
export const SavingUserPreferenceText = "Saving preference settings...";
export const UserPreferenceSuccessfullySavedText = "Preferences saved successfully.";
export const NewUserPreferenceSaveErrorText = "Failed to save preference changes. Please try again.";
export const StoreTableNameLabelText = "Store Name";
export const StoreTableMapVisibilityLabelText = "Map Visibility";
export const StoreTableLeadAssignmentLabelText = "Lead Assignment";
export const StoreTableStoreAddressLabelText = "Store Address";
export const SearchStoresInputText = "Search Stores";
export const StoreSearchNoResultsFound = "No stores found.";
export const StoreSettingsHeaderText = "Settings for ";
export const StoreSettingsLeadSectionText = "LEAD SETTINGS";
export const StoreSettingsMapSectionText = "DEALER LOCATOR MAP SETTINGS";
export const StoreSettingsRequiredFieldText = "Required Field (*)";
export const StoreSettingsLeadNotificationHelperText =
	"We will send an email when new leads are assigned to this location. It will not be shared with homeowners.";
export const StoreSettingsLeadNotificationMultiHelperText =
	"We will send an email when new leads are assigned to this location.";
export const StoreSettingsStoreEmailHelperText = "This email address will be displayed to homeowners.";
export const StoreSettingsReadOnlyNoteTitleText = "Sales Access Only";
export const StoreSettingsReadOnlyNoteText =
	"Tandem support personnel (such as Care) are unable to change any settings below. Please contact your Territory Sales Manager for assistance.";
export const StoreSettingsSaveSuccessText = "Store settings saved.";
export const StoreSettingsSaveFailedText = "Failed to save store settings. Please try again.";
export const StoreSettingsSaveLoadingText = "Saving Store Settings...";
export const StoreSettingsNoDataErrorButton = "Return To All Stores";
export const StoreSettingsEmailInvalidErrorText = "Please enter a valid Email Address";
export const StoreSettingsLeadNotificationMaxErrorText =
	"A maximum of 10 lead notification emails are allowed. Please remove one before adding another.";

// Bill To Settings Page
export const BillToSettingsHeaderText = "Settings for Bill To ";
export const BillToSettingsCartHeaderText = "ACKNOWLEDGEMENTS";
export const BillToSettingsCautionHeaderText = "Caution: Global Settings";
export const BillToSettingsCautionLine1Text =
	"These email addresses will receive acknowledgements for ALL orders placed using this Bill To.";
export const BillToSettingsCautionLine2Text =
	"Individuals have separate settings for acknowledgements on their orders under their personal settings.";
export const BillToDefaultSettingsText = "DEFAULT SETTINGS";
export const AcknowledgementConfigCardTitleText = "ACKNOWLEDGEMENT EMAIL ADDRESS #";
export const ReceiveAcknowledgementEmailsText =
	"This email address will receive acknowledgement emails for ALL orders placed using this Bill To.";
export const BillToSettingsMaxCards = 10;
export const MaxCardsErrorText =
	"A maximum of 10 email addresses are allowed. Please remove one before adding another.";
export const BillToEmailFieldUniqueErrorText = "Please enter a unique email address.";
export const BillToNoDataErrorButton = "Return To Admin Settings";
export const BillToSettingsSaveSuccessText = "Acknowledgement Settings Saved.";
export const BillToSettingsSaveFailedText = "Failed to save acknowledgement settings. Please try again.";
export const BillToEmailFieldTitle = "Email Acknowledgements To*";
export const BillToRemoveEmailButton = "REMOVE EMAIL ADDRESS";
export const BillToAddEmailButton = "ADD EMAIL ADDRESS";
export const BillToCancelEmailButton = "CANCEL";
export const BillToSaveEmailButton = "SAVE";
export const BillToSaveLoadingText = "Saving Acknowledgement Settings...";
export const BillToAcknowledgeLayoutTitle = "Acknowledgement Layout";
export const BillToAcknowledgeFormatTitle = "Acknowledgement Format";
export const PriceFormatList = "List Pricing";
export const PriceFormatNet = "Net Pricing";
export const PriceFormatNetWithMultiplier = "Net Pricing with Multiplier";
export const AcknowledgementExpandedViewLabel = "Expanded View";
export const AcknowledgementCondensedViewLabel = "Condensed View";
export const EmailFieldRequiredErrorText = "Please enter Email Address";
export const EmailFieldUniqueErrorText = "Please enter valid Email Address";
